import Navbar from "../Navbar";
import Hero from "../Hero";
import Footer from "../Footer";
import ContactForm from "../ContactForm";

function Contact(){
    return(
        <>
        <Navbar />
        <Hero
        cName="hero-mid"
        heroImg="/assert/ito.png"
        title="Contact"
        btnClass="hide"
        />
        <ContactForm />
        <Footer />
        </>
    );
}

export default Contact;